// extracted by mini-css-extract-plugin
export default {"wrapper":"zC-z","viewport":"AC-z","container":"BC-z","slide":"CC-z"};